export const data: any = {
  NEXT_PUBLIC_SITE_MACHINE_NAME: "corporate",
  NEXT_PUBLIC_CF_MXP_SPACE_ID: "citn2sn5tdjr",
  NEXT_PUBLIC_ONETRUST_ID: "c4b867da-0106-4cc2-85ba-b4958ea10d7e",
  NEXT_PUBLIC_ALGOLIA_SITE_INDEX: "global-production",
  NEXT_PUBLIC_NINETAILED_PREVIEW_ENABLED: true,
  NEXT_PUBLIC_NINETAILED_ENVIRONMENT: "main",
  NEXT_PUBLIC_NINETAILED_CLIENT_ID: "1120e1be-bcc5-4b05-bd8d-589ec716bf97",
  BYPASS_CONSENT_CHECK: true
}
